
import { ILookUpTypeDtoModel } from "../models/generic/lookup-type/lookup-type-dto.model";
import { ILookUpType } from "../models/generic/lookup-type/lookup-type.model";
import { IModelMapping } from "./generic/model.mapping";
export class LookUpTypeMapping implements IModelMapping<ILookUpTypeDtoModel, ILookUpType> {

    toApplicationModel(model: ILookUpTypeDtoModel): ILookUpType {
        return {
            ...model
        } as ILookUpType
    }

    toDtoModel(model: ILookUpType): ILookUpTypeDtoModel {
        return {
            ...model
        } as ILookUpTypeDtoModel
    }

    toDtoModels(models: ILookUpType[]): ILookUpTypeDtoModel[] {
        return models.map(m => this.toDtoModel(m));
    }

    toApplicationModels(models: ILookUpTypeDtoModel[]): ILookUpType[] {
        return models.map(m => this.toApplicationModel(m));
    }
}